// NotFound.js
import React from 'react';
import { Button, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function NotFound() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        textAlign: 'center',
      }}
    >
      <Typography variant="h4" gutterBottom>
        Il n&apos;y a rien ici ?
      </Typography>
      <Button variant="contained" color="primary" onClick={handleGoHome}>
        Accueil
      </Button>
    </Box>
  );
}

export default NotFound;
